module.exports = __webpack_public_path__ + "assets/a5be01095bf953eee957d8ebee55447e.png";